import React from "react";
import IteratorInput from "./IteratorInput";
import PaginationInput from "./pagination/PaginationInput";
import RateLimit from "./RateLimit";
import Tabs, { Tab, TabList, TabPanel } from "@atlaskit/tabs";

const BehaviourTabPage = ({ action }) => {
  return (
    <>
      <p className="ihub-action-tab-description">
        Here you can set up what you want each action to do. You can choose options for collecting multiple pages of information or repeating the
        action several times based a previous step.
      </p>
      <Tabs>
        <TabList>
          <Tab>Iterator</Tab>
          <Tab>Pagination</Tab>
          <Tab>Rate Limiting for External Calls</Tab>
        </TabList>
        <TabPanel>
          <div className="ihub-log-tab-warpper">
            <IteratorInput action={action} />
          </div>
        </TabPanel>
        <TabPanel>
          <div className="ihub-log-tab-warpper">
            <PaginationInput action={action} />
          </div>
        </TabPanel>
        <TabPanel>
          <div className="ihub-log-tab-warpper">
            <RateLimit action={action} />
          </div>
        </TabPanel>
      </Tabs>
    </>
  );
};

export default BehaviourTabPage;
